import React from 'react';
import { PROOF_STATS } from '../variants';
import { Eyebrow, Heading, Reveal, Section } from './primitives';

// TODO verify: testimonials came with the Rocket export; confirm they are real
// before this page gets paid traffic.
const TESTIMONIALS = [
  { quote: "I've tried every meditation app out there. DepthMe is the first one that actually feels like it knows me. Hearing my own voice guide me through the ritual is something else entirely.", name: 'Sarah M.', role: 'Entrepreneur' },
  { quote: "I didn't realize how loud my inner critic was until DepthMe helped me see the patterns. Three weeks in and my mornings feel completely different.", name: 'James T.', role: 'Software Engineer' },
  { quote: "The Shadow Work sessions hit different. I've done therapy, journaling, everything — but having a personalized ritual in my own voice? That's next level.", name: 'Priya K.', role: 'Creative Director' },
  { quote: "I was skeptical. Now I do my Morning Intentions every single day without fail. It's the only habit that's actually stuck.", name: 'Marcus R.', role: 'Fitness Coach' },
  { quote: "DepthMe helped me catch the thought loops I didn't even know I was running. The Night Reflections alone are worth it.", name: 'Leila H.', role: 'Therapist' },
  { quote: "I've recommended this to every person I know who's working on themselves. It's not a meditation app — it's a mind training system.", name: 'David C.', role: 'Life Coach' },
];

const TRUST = ['4.9 on the App Store', 'Private & secure', 'No credit card required', 'Start in minutes'];

export default function SocialProof() {
  return (
    <Section>
      <Reveal className="text-center">
        <Eyebrow>Real people. Real shifts.</Eyebrow>
        <Heading lines={['Thousands are already', 'training their mind.']} className="text-3xl md:text-5xl" />
      </Reveal>

      <Reveal className="mt-12">
        <dl className="grid grid-cols-2 gap-3 md:grid-cols-4">
          {PROOF_STATS.map((s) => (
            <div key={s.label} className="glass-card px-4 py-6 text-center">
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-jakarta text-3xl font-light text-gradient-gold">{s.value}</dd>
              <dd className="mt-1 text-[11px] uppercase tracking-wider text-white/50">{s.label}</dd>
            </div>
          ))}
        </dl>
      </Reveal>

      <div className="mt-8 grid gap-4 md:grid-cols-2">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 2) * 0.08}>
            <figure className="glass-card h-full p-6">
              <div aria-label="5 stars" className="text-sm tracking-widest text-[#F5A623]">★★★★★</div>
              <blockquote className="mt-3 font-jakarta text-lg italic leading-snug text-white/85">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-4 text-sm text-white/50">
                <span className="text-white">{t.name}</span> · {t.role}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-10">
        <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-white/50">
          {TRUST.map((t) => (
            <li key={t} className="flex items-center gap-2">
              <span className="h-1 w-1 rounded-full bg-[#F5A623]" />
              {t}
            </li>
          ))}
        </ul>
      </Reveal>
    </Section>
  );
}
